var MeetingService = /** @class */ (function () {
    /*@ngInject*/
    function MeetingService($rootScope, $filter, moment, StorageService, genericServiceAjs) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.moment = moment;
        this.StorageService = StorageService;
        this.genericServiceAjs = genericServiceAjs;
        this.urlConstants = {
            GET_MEETING_MODES: 'chime/meeting/getmeetingmodes',
            GET_MEETING_LINK: 'chime/meeting/getmeetinglink',
            JOIN_MEETING: 'chime/meeting/joinmeeting',
            CREATE_ATTENDEE: 'chime/meetings/createattendee',
            INVITE_PARTICIPANT: 'chime/meeting/inviteparticipant',
            ADD_PARTICIPANT: 'chime/meeting/addparticipanttomeeting',
            GET_SCHEDULE_DETAILS: 'chime/meeting/getmeetingscheduledetails',
            GIVE_FEEDBACK_EDIT_APPROVAL: 'chime/meeting/givefeedbackeditapproval',
            REMOVE_ATTENDEE_FROM_MEETING: 'chime/meeting/removeparticipantfrommeeting',
            GET_FEEDBACK_EDIT_ENABLED_ATTENDEE_ID: 'chime/meeting/getFeedbackEditEnabledUser',
            REQUEST_FEEDBACK_EDIT: 'chime/meeting/requestFeedbackEditApproval',
            GET_PRIMARY_HOST_ATTENDEE_ID: 'chime/meeting/getPrimaryHostUser',
            MAKE_USER_PRIMARY_HOST: 'chime/meeting/makeUserAsPrimaryHost',
            CHECK_STEP_CHANGE_POSSIBILITY: 'chime/meeting/checkStepChangePossibility'
        };
        this.enableFeedbackEditForUserId = null;
    }
    MeetingService.prototype.getMeetingModes = function (successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_MEETING_MODES).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.getMeetingLink = function (scheduleId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_MEETING_LINK + '/' + scheduleId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.joinMeeting = function (scheduleId, participantId, participantType, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + this.urlConstants.JOIN_MEETING + '/' + participantType + '/' + scheduleId + '/' + participantId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.createAttendee = function (meetingInfo, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + 'chime/meeting/createattendee', meetingInfo).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.inviteParticipant = function (participantInfo, isMeetingInProgress, successCallback, errorCallback) {
        var url = this.StorageService.get('baseurl') + this.urlConstants.INVITE_PARTICIPANT + '?isMeetingInProgress=' + isMeetingInProgress;
        this.genericServiceAjs.addObject(url, participantInfo).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.addParticipant = function (participantsInfo, successCallback, errorCallback) {
        var url = this.StorageService.get('baseurl') + this.urlConstants.ADD_PARTICIPANT;
        this.genericServiceAjs.addObject(url, participantsInfo).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.getScheduleDetails = function (scheduleId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_SCHEDULE_DETAILS + '/' + scheduleId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.giveFeedbackEditApproval = function (approvalDetails, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + this.urlConstants.GIVE_FEEDBACK_EDIT_APPROVAL, approvalDetails).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.removeAttendeeFromMeeting = function (attendeeDetails, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + this.urlConstants.REMOVE_ATTENDEE_FROM_MEETING, attendeeDetails).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.getFeedbackEditEnabledAttendeeId = function (meetingId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_FEEDBACK_EDIT_ENABLED_ATTENDEE_ID + '/' + meetingId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.getFeedbackEditRequestApproval = function (requestDetails, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + this.urlConstants.REQUEST_FEEDBACK_EDIT, requestDetails).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.getPrimaryHostAttendeeId = function (externalMeetingCallId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_PRIMARY_HOST_ATTENDEE_ID + '/' + externalMeetingCallId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.makeUserPrimaryHost = function (requestDetails, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + this.urlConstants.MAKE_USER_PRIMARY_HOST, requestDetails).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    MeetingService.prototype.getMoveToInterviewStepPossibility = function (externalMeetingCallId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.CHECK_STEP_CHANGE_POSSIBILITY + '/' + externalMeetingCallId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    //common methods
    MeetingService.prototype.getMeetingUrl = function (scheduleId, workflowStep, mode) {
        return this.StorageService.get('baseurl') + '/#/conference?sh=' + scheduleId + '&ws=' + workflowStep + '&mode=' + mode;
    };
    MeetingService.prototype.getMassagedMeetingDetails = function (meetingDetails) {
        var meeting = {};
        meeting.id = meetingDetails.meetingScheduleId;
        meeting.candidateDetail = meetingDetails.candidateDetail;
        meeting.roleName = meetingDetails.roleName;
        meeting.reqNumber = meetingDetails.reqNumber;
        meeting.notesDisplay = "";
        meeting.status = meetingDetails.meetingStatus;
        meeting.candidateDetail = meetingDetails.candidateDetail;
        meeting.company = meetingDetails.company;
        meeting.jobMatchId = meetingDetails.jobMatchId;
        meeting.jobType = meetingDetails.jobType;
        meeting.contractDuration = meetingDetails.contractDuration;
        meeting.requisitionBelongsTo = meetingDetails.requisitionBelongsTo ? meetingDetails.requisitionBelongsTo.name : "";
        meeting.requisitionNote = meetingDetails.requisitionNote;
        meeting.clientNote = meetingDetails.clientNote;
        // if(!_.isNull(meetingDetails.internalNote) && meetingDetails.internalNote.length > 0) {
        //     if(this.candidateJobMatch.isSharedRequisition) {
        //         meeting.notesDisplay = meeting.notesDisplay + "<b>Internal Note: </b> <p>" + this._replaceSpecialCharacters(meetingDetails.internalNote) + "</p>";
        //     } else {
        //         meeting.notesDisplay = meeting.notesDisplay + "<b>Note: </b><p>" + this._replaceSpecialCharacters(meetingDetails.internalNote) + "</p>";
        //     }
        // }
        // if(!_.isNull(meetingDetails.externalNote) && meetingDetails.externalNote.length > 0) {
        //     meeting.notesDisplay = meeting.notesDisplay + "<b>External Note: </b><br><p>" + this._replaceSpecialCharacters(meetingDetails.externalNote) + "</p>";
        // }
        // if(meeting.notesDisplay.length > 0) {
        //     meeting.notesDisplay = "<div class='text-left' style='padding-top:8px'>" + meeting.notesDisplay + "</div>"
        // }
        // meeting.notesTooltipIsOpen = false;
        // switch(meeting.status) {
        //     case 'SCHEDULED':
        //         meeting.statusClass = 'fa fa-calendar job-match-meetings-meeting-icon-scheduled';
        //         meeting.statusLabel = 'Scheduled';
        //         meeting.feedbackEnabledFlag = true;
        //         break;
        //     case 'IN_PROGRESS':
        //         meeting.statusClass = 'fa fa-hourglass-half job-match-meetings-meeting-icon-in-progress';
        //         meeting.statusLabel = 'In Progress';
        //         meeting.feedbackEnabledFlag = true;
        //         break;
        //     case 'COMPLETED':
        //         meeting.statusClass = 'fa fa-check job-match-meetings-meeting-icon-completed';
        //         meeting.statusLabel = 'Completed';
        //         meeting.feedbackEnabledFlag = true;
        //         break;
        //     case 'OVERDUE':
        //         meeting.statusClass = 'fas fa-clock job-match-meetings-meeting-icon-overdue';
        //         meeting.statusLabel = 'Overdue';
        //         meeting.feedbackEnabledFlag = true;
        //         break;
        //     case 'CANCELLED':
        //         meeting.statusClass = 'fa fa-ban job-match-meetings-meeting-icon-cancelled';
        //         meeting.statusLabel = 'Canceled';
        //         meeting.feedbackEnabledFlag = false;
        //         meeting.feedbackTooltip = 'Feedback is disabled.';
        //         break;
        //     default:
        //         // set defaults
        //         meeting.statusClass = 'fa fa-question job-match-meetings-meeting-icon-in-progress';
        //         meeting.statusLabel = 'Status Unknown';
        //         meeting.feedbackEnabledFlag = false;
        //         meeting.feedbackTooltip = 'Feedback is disabled.';
        // }
        var startDateTime = new Date(meetingDetails.startTime);
        var endDateTime = new Date(meetingDetails.endTime);
        meeting.timeZone = _.isNull(meetingDetails.timeZoneName) ? '-' : meetingDetails.timeZoneName;
        if (meeting.timeZone != '-') {
            meeting.scheduledDateInBrowserTimeZone = startDateTime;
            meeting.scheduledTimeLabelInBrowserTimeZone = this.$filter('fourdotfiveTimeFormat')(startDateTime) + ' to ' + this.$filter('fourdotfiveTimeFormat')(endDateTime);
            var startDateTimeStringInSelectedTimeZone = this.moment(startDateTime).tz(meeting.timeZone).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var startDateTimeInSelectedTimeZone = new Date(startDateTimeStringInSelectedTimeZone);
            var endDateTimeStringInSelectedTimeZone = this.moment(endDateTime).tz(meeting.timeZone).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var endDateTimeInSelectedTimeZone = new Date(endDateTimeStringInSelectedTimeZone);
            meeting.scheduledDate = new Date(startDateTimeInSelectedTimeZone);
            meeting.scheduledTimeLabel = this.$filter('fourdotfiveTimeFormat')(startDateTimeInSelectedTimeZone) + ' to ' + this.$filter('fourdotfiveTimeFormat')(endDateTimeInSelectedTimeZone);
        }
        else {
            meeting.scheduledDate = startDateTime;
            meeting.scheduledTimeLabel = this.$filter('fourdotfiveTimeFormat')(startDateTime) + ' to ' + this.$filter('fourdotfiveTimeFormat')(endDateTime);
        }
        meeting.usersList = [];
        meeting.usersListToDisplay = [];
        meeting.showPhoneNumbers = meetingDetails.participants.some(function (participant) { return participant.showPhoneNumber; });
        angular.forEach(meetingDetails.participants, function (meetingUser, key) {
            var user = {};
            user.userId = meetingUser.id;
            user.userName = meetingUser.firstName;
            if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                user.userName += ' ' + meetingUser.lastName;
            }
            user.role = meetingUser.role;
            user.isPoc = meetingUser.isPoc;
            user.email = _.isNull(meetingUser.email) ? '-' : meetingUser.email;
            user.phoneNumber = _.isNull(meetingUser.phoneNumber) || !meetingUser.showPhoneNumber ? '-' : meetingUser.phoneNumber;
            user.title = _.isNull(meetingUser.title) ? '-' : meetingUser.title;
            // if(this.isCorporate) {
            //     meeting.showFeedback = true;
            // } else {
            //     meeting.showFeedback = this._getUserAccess(meetingUser.company.id);
            // }
            meeting.usersList.push(user);
            // if(!_.isNull(meetingUser.participantMeetingEmailDeliveryDetails)) {
            //     let emailDeliveryDetails = meetingUser.participantMeetingEmailDeliveryDetails[0];
            //     if(emailDeliveryDetails.participantEmail == user.email) {
            //         user.emailSendToParticipant = emailDeliveryDetails.emailSendToParticipant;
            //         user.emailDeliveryReason = emailDeliveryDetails.reason;
            //     }
            //     if(user.emailSendToParticipant) {
            //         user.emailDeliveryReason = "Email delivered.";
            //     } else if(_.isNull(user.emailDeliveryReason) || user.emailDeliveryReason == "") {
            //         user.emailDeliveryReason = "Email not delivered.";
            //     }
            // }
            // if(this.candidateJobMatch.isSharedRequisition && !this.isCorporate) {
            //     if(user.isPoc) {
            //         meeting.usersListToDisplay.push(user);
            //     }
            // } else {
            meeting.usersListToDisplay.push(user);
            // }
        });
        // if(!_.isNull(meetingDetails.candidateMeetingEmailDeliveryInfo)) {
        //     let candidateEmailDeliveryDetails = meetingDetails.candidateMeetingEmailDeliveryInfo[0];
        //     meeting.emailSendToCandidate = candidateEmailDeliveryDetails.emailSendToCandidate;
        //     meeting.emailDeliveryReason = candidateEmailDeliveryDetails.reason;
        //     if(meeting.emailSendToCandidate) {
        //         meeting.emailDeliveryReason = "Email delivered.";
        //     } else if(_.isNull(meeting.emailDeliveryReason) || meeting.emailDeliveryReason == "") {
        //         meeting.emailDeliveryReason = "Email not delivered.";
        //     }
        // }
        return meeting;
    };
    MeetingService.prototype.getUserIdOfFeedbackEditor = function () {
        if (this.enableFeedbackEditForUserId == null) {
            this.enableFeedbackEditForUserId = this.$rootScope.userDetails.id;
        }
        return this.enableFeedbackEditForUserId;
    };
    return MeetingService;
}());
export { MeetingService };
//# sourceMappingURL=meetingService.js.map